import React from "react";
import { Stack, Typography } from "@mui/material";
import { HubHookFormInput } from "../../components";
import { StyledBarcode } from "./styles";

const columns = ["Left", "Center", "Right"];

export const BarcodeDetails = ({ disabled = false }) => {
  return (
    <Stack
      width="100%"
      gap="5px"
      sx={{
        ".mustache": {
          backgroundColor: "#fff4c2",
          color: "#c08401",
        },
      }}
    >
      <Typography variant="boldCaptionMain">Barcode Details</Typography>
      <Stack width="100%" gap="15px">
        <Stack direction="row" gap="5px">
          {columns.map((label, index) => (
            <HubHookFormInput
              name={`top.${index}`}
              placeholder={`Top ${label}`}
              disabled={disabled}
            />
          ))}
        </Stack>
        <StyledBarcode barcode="00000Test-Example" />
        <Stack direction="row" gap="5px">
          {columns.map((label, index) => (
            <HubHookFormInput
              name={`bottom.${index}`}
              placeholder={`Bottom ${label}`}
              disabled={disabled}
            />
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
};
